/**
 * Package: nfosongcycleGSAP
 *
 * NFO Song Cycle GSAP support and methods
 */

/**
 * Safe(r) shortcut for jQuery.
 */
if ( !$j ) {
    var $j = jQuery.noConflict();
}
        
// Register GSAP scroll trigger.
// GSAP is only enqueued on pages that use it - without this guard a missing
// library throws here, and because every module is concatenated into one
// assets/js/main.js that takes the rest of the theme's JS down with it.
if ( 'undefined' !== typeof gsap && 'undefined' !== typeof ScrollTrigger ) {
    gsap.registerPlugin( ScrollTrigger );
}

var nfosongcycleGSAP = {
    /**
     * Initialize on document ready
     *
     * @return void
     */
    init: function() {
        // Init methods
        
        // methods that need to know about resize
        $j( window ).on( 'resize', function() {
            
        } );
    },
};

// Call init on ready
$j( nfosongcycleGSAP.init );
